import React from 'react';
import PropTypes from 'prop-types';

import AlbumGreenScreenUploadCheck from './AlbumGreenScreenUploadCheck';
import withModal from '../modal/withModal';

export const ALBUM_GREEN_SCREEN_UPLOAD_CHECK_MODAL =
  'MODAL/ALBUM_GREEN_SCREEN_UPLOAD_CHECK';

const propTypes = {
  actionProps: PropTypes.shape({
    albumId: PropTypes.string,
    hasTeamTag: PropTypes.bool,
    onSuccess: PropTypes.func,
  }),
};

const AlbumGreenScreenUploadCheckModal = ({ actionProps = {}, ...props }) => {
  const { albumId, hasTeamTag, onSuccess } = actionProps;
  return (
    <AlbumGreenScreenUploadCheck
      albumId={albumId}
      hasTeamTag={hasTeamTag}
      onSuccess={onSuccess}
      {...props}
    />
  );
};

AlbumGreenScreenUploadCheckModal.propTypes = propTypes;

export default withModal(AlbumGreenScreenUploadCheckModal, {
  name: ALBUM_GREEN_SCREEN_UPLOAD_CHECK_MODAL,
  size: 'sm',
  type: 'full',
});
